import React, {memo, useEffect} from "react";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import PropTypes from "prop-types";
import GroupForm from "../Forms/GroupForm";
import {requestPermissionList, requestUserList} from "../../redux/Actions/group.action";
import {useDispatch, useSelector} from "react-redux";
import {getGroupModalData} from "../../redux/Selectors/group.selector";
import Loader from "../Loader";

const AddGroup = (props) => {
  const dispatch = useDispatch();
  const groupModalData = useSelector(getGroupModalData);
  const {open, onClose} = props;

  useEffect(() => {
    dispatch(requestPermissionList());
    dispatch(requestUserList());
  }, [dispatch]);

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
        <Loader />
        <ModalHeader>{groupModalData?.id ? "Edit Group" : "Add Group"}</ModalHeader>
        <ModalBody>
          <div className="pl-lg-4">
            <GroupForm onClose={onClose} />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

AddGroup.propTypes = {
  open: PropTypes.bool,
};
export default memo(AddGroup, areEqual);
